import { Injectable, signal } from '@angular/core';

/**
 * 簡易認証サービス（UI 内部で完結）。
 * バックエンド API とは通信せず、固定資格情報との照合のみで認証する。
 * ログイン状態は localStorage に保持し、リロード後も維持する。
 */
@Injectable({ providedIn: 'root' })
export class AuthService {
  /**
   * 固定の資格情報。
   * ※ 変更する場合はここを書き換える（UI 内部解決のためコードに直接保持）。
   */
  private static readonly CREDENTIAL = { nickname: 'admin', password: 'W*zzeDt7v@iXpGx' } as const;

  /** localStorage のキー */
  private static readonly STORAGE_KEY = 'qualitrack.auth';

  /** 認証済みフラグ（localStorage の値で初期化） */
  private readonly authedSig = signal<boolean>(this.readStorage());

  /** 認証状態の読み取り用 */
  readonly isAuthenticated = this.authedSig.asReadonly();

  /**
   * ログイン。資格情報が一致した場合のみ true を返し、状態を保存する。
   */
  login(nickname: string, password: string): boolean {
    const ok =
      nickname === AuthService.CREDENTIAL.nickname &&
      password === AuthService.CREDENTIAL.password;
    if (ok) {
      this.authedSig.set(true);
      this.writeStorage(true);
    }
    return ok;
  }

  /** ログアウト。状態を破棄する。 */
  logout(): void {
    this.authedSig.set(false);
    this.writeStorage(false);
  }

  /** localStorage から認証状態を読み込む（SSR 等を考慮し存在チェック）。 */
  private readStorage(): boolean {
    if (typeof localStorage === 'undefined') {
      return false;
    }
    return localStorage.getItem(AuthService.STORAGE_KEY) === 'true';
  }

  /** localStorage へ認証状態を書き込む。 */
  private writeStorage(value: boolean): void {
    if (typeof localStorage === 'undefined') {
      return;
    }
    if (value) {
      localStorage.setItem(AuthService.STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(AuthService.STORAGE_KEY);
    }
  }
}
